import React, { useState, useEffect } from "react";
import bgimage from "../../assets/game/background.png";
import rock from "../../assets/game/rock.png";
import characterImage from "../../assets/game/character.png";
import pathFill from "../../assets/game/pathF.png";
import pathEmpty from "../../assets/game/pathE.png";
import flagImage from '../../assets/game/targetFlag.png'
import Gift from  '../../assets/game/gift.png'
import Board from '../../assets/game/offerBoard.png'



import Bronze from "../../assets/game/bronze-medal.png";
import Sliver from "../../assets/game/Sliver.png";
import Gold from '../../assets/game/Gold.png'
import Platinum from  '../../assets/game/Platinum.png'
import BackArrow from '../../assets/game/backArrow.png'
import NextArrow from '../../assets/game/NextArrow.png'


const MilestonePagination = () => {
  const totalMilestones = 10; // Total milestones from API
  const milestonesPerPage = 5;
  const currentLevelMilestoneCount = 7; // Current character position from API

  // Calculate total pages
  const totalPages = Math.ceil(totalMilestones / milestonesPerPage);

  // Calculate current page based on the current milestone count
  const initialPage = Math.ceil(currentLevelMilestoneCount / milestonesPerPage);

  // State to manage the current page
  const [currentPage, setCurrentPage] = useState(initialPage);

  // Calculate milestones for the current page
  const startMilestone = (currentPage - 1) * milestonesPerPage + 1;
  const endMilestone = startMilestone + milestonesPerPage - 1;

  // Determine the current milestone's page
  const currentMilestonePage = Math.ceil(currentLevelMilestoneCount / milestonesPerPage);

  const leftPositions = ["14vw", "26vw", "50vw", "66vw", "88vw"];
  const leftPositionsChar = ["18vw", "29vw", "56vw", "70vw", "78vw"];
  const TopPositionsChar = ["36vw", "36vw", "34vw", "36vw", "46vw"];


  // Handlers for Next and Previous buttons
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };




  const getPagePathImage = () => {

  
    // If the current milestone is equal to the total milestones, show filled path
    if (currentLevelMilestoneCount === totalMilestones) {
      return pathFill; // Last milestone filled
    } 
    
    // If the current page is before the milestone page, show filled path
    if (currentPage < currentMilestonePage) {
      return pathFill; // Previous pages
    } 
    
    // If the current page is after the milestone page, show empty path
    if (currentPage > currentMilestonePage) {
      return pathEmpty; // Future pages
    }
  
    // Handle the current milestone page
    if (currentPage === currentMilestonePage) {
      if (currentLevelMilestoneCount % milestonesPerPage === 0) {
        return pathFill; // Show filled path for multiples of milestonesPerPage
      }
      return require(`../../assets/game/path${((currentLevelMilestoneCount - 1) % milestonesPerPage) + 1}.png`);
    }
  
    // Default fallback
    return pathEmpty;
  };
  
  const Medal = () => {
    const [allmodelShow, SetallmodelShow] = useState(false);
  
    const handleShowAllModels = () => {
      SetallmodelShow(!allmodelShow);
    };
  
    return (
      <>
        <div
          style={{
            background: "linear-gradient(180deg, #239FBD 80.53%, rgba(131, 211, 231, 0) 93.66%)",
            height: "10vw",
            position: "absolute",
            top: 0,
          }}
        >
          <div style={{ display: "flex", padding: "5%", alignItems: "center" }}>
            <div>
              <img src={Bronze} style={{ width: "10vw" }} />
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700"}}>Bronze</h1>
            </div>
            <div>
              <img src={Sliver} style={{ width: "10vw", }} />
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700",marginLeft:"4px",marginTop:"5px"}}>Sliver</h1>
            </div>
            <div
              style={{
                width: "10vw",
                display: allmodelShow ? "block" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
              }}
            >
              <img src={Gold} style={{ width: "100%" }} />
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700",marginLeft:"4px",marginTop:"5px"}}>Gold</h1>
            </div>
            <div
              style={{
                width: "10vw",
                display: allmodelShow ? "block" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
              }}
            >
              <img src={Platinum} style={{ width: "100%" }} />
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700"}}>Platinum</h1>
            </div>
            <div
              style={{
                width: "5vw",
                display: allmodelShow ? "flex" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
              }}
              onClick={handleShowAllModels}
            >
              <img src={BackArrow} style={{ width: "100%" }} />
            </div>
            <div
              style={{
                width: "5vw",
                display: allmodelShow ? "none" : "flex",
                opacity: allmodelShow ? 0 : 1,
                transition: "opacity 5s ease-in-out",
              }}
              onClick={handleShowAllModels}
            >
              <img src={NextArrow} style={{ width: "100%" }} />
            </div>
          </div>
        </div>
      </>
    );
  };
  

  const Rock = () => {
    return (
      <>



     
        <div style={{ position: "absolute", top: "51vw", left: "7vw", zIndex: 2 }}>
          <img style={{ width: "18vw" }} src={rock} alt="Rock" />
        </div>
        <div style={{ position: "absolute", top: "24vw", left: "20vw", zIndex: 2 }}>
          <img style={{ width: "18vw" }} src={rock} alt="Rock" />
        </div>
        <div style={{ position: "absolute", top: "51vw", left: "44vw", zIndex: 2 }}>
          <img style={{ width: "18vw" }} src={rock} alt="Rock" />
        </div>
        <div style={{ position: "absolute", top: "24vw", left: "60vw", zIndex: 2 }}>
          <img style={{ width: "18vw" }} src={rock} alt="Rock" />
        </div>
        <div style={{ position: "absolute", top: "51vw", left: "83vw", zIndex: 2 }}>
          <img style={{ width: "18vw" }} src={rock} alt="Rock" />
        </div>
      </>
    );
  };

  useEffect(() => {


  }, [currentPage]);

  const levelRewards = {
    "status": {
        "success": true,
        "code": "OK",
        "message": "Success",
        "timestamp": "2025-01-09T09:45:08.127970707Z"
    },
    "data": {
        "levelImage": "/test",
        "levelId": 6,
        "levelName": "Platinum",
        "totalMilestones": 45,
        "currentLevelMilestoneCount": 2,
        "daysLeft": 27,
        "levelRewards": [
          {
            "milestoneCount": 7,
            "rewardType": "cashback",
            "value": 15.0,
            "isSurprise": false,
            "isRedeemed": false
        },
        {
          "milestoneCount": 8,
          "rewardType": "cashback",
          "value": 15.0,
          "isSurprise": false,
          "isRedeemed": false
      },
            {
                "milestoneCount": 5,
                "rewardType": "cashback",
                "value": 15.0,
                "isSurprise": true,
                "isRedeemed": false
            },
            {
                "milestoneCount": 29,
                "rewardType": "cashback",
                "value": 20.0,
                "isSurprise": false,
                "isRedeemed": false
            }
        ]
    }
}
  const rewardPositionData = [
    { imageTop: "43vw", imageLeft: "8vw", textTop: "43vw", textLeft: "9vw" },
    { imageTop: "16vw", imageLeft: "27vw", textTop: "16vw", textLeft: "28vw" },
    { imageTop: "43vw", imageLeft: "43vw", textTop: "43vw", textLeft: "44vw" },
    { imageTop: "17vw", imageLeft: "67vw", textTop: "17vw", textLeft: "68vw" },
    { imageTop: "46vw", imageLeft: "78vw", textTop: "46vw", textLeft: "79vw" },
    // Add more positions for future pages or use a dynamic system
  ];

  // Level Rewards mapping



  return (
    <div>
      <Rock />
      <img src={bgimage} alt="Background" />
      {/* Navigation Buttons */}
      <div
        onClick={handleNext}
        style={{ position: "absolute", zIndex: 4, top: "31vw", right: 0 }}
      >
        <img style={{ width: "50px" }} src="next-icon.png" alt="Next" />
      </div>
      <div
        onClick={handlePrev}
        style={{ position: "absolute", zIndex: 4, top: "31vw" }}
      >
        <button>Prev</button>
      </div>

      {/* Milestones */}
      <div>
        {Array.from({ length: milestonesPerPage }).map((_, index) => (
          <div key={index}>
            <h1
              style={{
                color: "white",
                fontSize: "6vw",
                position: "absolute",
                fontWeight: "bold",
                zIndex: 3,
                top: `${index % 2 === 0 ? "50vw" : "23vw"}`,
                left: leftPositions[index],
              }}
            >
              {startMilestone + index}
            </h1>
          </div>
        ))}
      </div>

      {/* Character only on current milestone */}
     
      {currentLevelMilestoneCount >= startMilestone && currentLevelMilestoneCount <= endMilestone && (
        <>
        <img
          src={characterImage}
          alt="Character"
          style={{
            position: "absolute",
            width: "13vw",
            top: `${TopPositionsChar[(currentLevelMilestoneCount - 1) % milestonesPerPage]}`,

        
            left:`${leftPositionsChar[(currentLevelMilestoneCount - 1) % milestonesPerPage]}` ,
            zIndex: 5,
          }}
         
        />
    </>
      )}

{levelRewards&&levelRewards.data&&levelRewards.data.levelRewards.map((reward) => {
  // Determine the page of the reward
  const rewardPage = Math.ceil(reward.milestoneCount / milestonesPerPage);

  // Only render rewards for the current page
  if (rewardPage === currentPage) {
    // Find the position of the reward within the current page
    const rewardIndex = (reward.milestoneCount - startMilestone) % milestonesPerPage;
    const rewardPosition = rewardPositionData[rewardIndex];

    if (rewardPosition) {
      return (
        <React.Fragment key={reward.milestoneCount}>
          {/* Conditional Rendering: Regular Reward or Surprise Gift Card */}
          {reward.isSurprise ? (
            // Render a separate div for the surprise reward with the gift card image
            <div
              style={{
                position: "absolute",
                top: rewardPosition.imageTop,
                left: rewardPosition.imageLeft,
                zIndex: 6,
              }}
            >
              <img
                src={Gift} // Replace with the actual gift card image path
                alt="Gift Card"
                style={{
                  width: "13vw",
                }}
              />
     
            </div>
          ) : (
            // Regular reward rendering
            <React.Fragment key={reward.milestoneCount}>
            {/* Reward Image */}
            <img
              src={Board}
              alt={`Reward for milestone ${reward.milestoneCount}`}
              style={{
                position: "absolute",
                width: "13vw",
                top: rewardPosition.imageTop,
                left: rewardPosition.imageLeft,
                zIndex: 6,
              }}
            />
            {/* Reward Text */}
            <div
              style={{
                position: "absolute",
                top: rewardPosition.textTop,
                left: rewardPosition.textLeft,
                zIndex: 7,
              }}
            >
              <p style={{textAlign:"center",fontSize:"3vw",color:"white",fontWeight:"900"}}>{reward.value}%</p>
              <h1 style={{ fontSize: "2.7vw", color: "white", textAlign: "center",    marginTop: "-2vw" }}>
                
                {reward.rewardType}
              </h1>
            </div>
          </React.Fragment>
          )}
        </React.Fragment>
      );
    }
  }
  return null;
})}
{currentPage === totalPages && (
        <img
          src={flagImage}
          alt="Flag"
          style={{
            position: "absolute",
            width: "10vw",
            top: `43vw`,
            left: `89vw`,
            zIndex: 10,
          }}
        />
      )}

      {/* Single Path Image */}
      <img
        src={getPagePathImage()}
        alt="Path"
        style={{
          position: "absolute",
          width: "100vw",
          top: "30vw",
          left: "0vw",
          zIndex: 1,
        }}
      />
      <Medal/>
    </div>
  );
};

export default MilestonePagination;